<template>
    <link-input class="link-address-input"
                :value="showValue"
                :suffix-icon="suffixIcon"

                :type="type"
                :color="color"
                :size="size"
                :shape="shape"
                :placeholder="placeholder"
                :disabled="lv_disabled"
                :width="width"
                :long="long"
                :hide-clear-icon="hideClearIcon"

                input-readonly
                :required="required"
                :validate-on-init="validateOnInit"
                :rules="rules"
                :clear-on-click-delete-icon="false"
                @click-suffix-icon="!lv_disabled&&!lv_readonly && handleClickSuffixIcon()"
                @click="!lv_disabled&&!lv_readonly && handleClick()"
    />
</template>

<script>
    import LinkInput from "../input/link-input";
    import {EditMixin} from "../mixins";

    export default {
        name: "link-address-input",
        components: {LinkInput},
        mixins: [EditMixin],
        props: {
            row: {require: true},
            map: {require: true},
            /*@formatter:off*/
            types: {type: Array, default: () => {return ['province', 'city', 'district']}},                 // 设定link-address-modal的类型和返回数据形式
            title: {type: String, default:()=> LinkVue.$t('LinkForm.pickAddress')},                                                    // 设定弹框标题
            shadow: {type: Boolean, default: true},                                                         // 设定弹框是否有遮罩层
            /*@formatter:on*/

            placeholder: {type: String, default: ()=> LinkVue.$t('LinkForm.selectPlaceholder')},                                                       // 设置input框的提示语
            type: {type: String, default: 'line'},                                                          // 设置input框的类型样式
            color: {type: String, default: 'info'},                                                         // 设置input框的颜色
            size: {type: String, default: 'default'},                                                       // 设置input框的大小
            width: {type: Number, default: 200},                                                            // 设置input框的长度
            long: {type: Boolean,},
            hideClearIcon: {type: Boolean},

            shape: {type: String, default: 'none'},                                                         // 设置input框的形状
            suffixIcon: {type: String, default: 'link-icon-location'},
            required: {type: Boolean},
            rules: {type: Array | String},
            validateOnInit: {type: Boolean,},
			mutiple: {type: Boolean, default: false},                                                      // 是否多选
			isDefault: {type: Boolean, default: true},                                                     // 是否设置默认值
        },
        data() {
            return {
                advances: this.$lv.$address.advances
            }
        },
        computed: {
            showValue() {

                let ret;
                if (this.types.length === 1) {
                    ret = this.row[this.map[this.types[0]]]
                } else ret = this.types
                    .sort((a, b) => this.advances[b] - this.advances[a])
                    .reduce((ret, key) => {
                        !!this.row[this.map[key]] && ret.push(this.row[this.map[key]])
                        return ret
                    }, [])
                    .join('/')
                return ret
            },
            param() {
                return Object.keys(this.map).reduce((ret, key) => {
                    ret[key] = this.row[this.map[key]]
                    return ret
                }, {})
            },
        },
        methods: {
            handleClick() {
				this.$lv.$address.pick({
                    types: this.types,
                    param: this.param,
                    title: this.title,
                    shadow: this.shadow,
					mutiple: this.mutiple,
					isDefault: this.isDefault,
                    onConfirm: this.handleConfirm
                })
            },
            handleConfirm(val) {
                this.types.forEach(type => this.$set(this.row, this.map[type], val[type]))
                /*清空低优先级地址值*/
                for (let mapKey in this.map) {
                    let lowAdvance = true;
                    for (let index in this.types) {
                        let type = this.types[index]
                        // console.log(this.advances[mapKey], this.advances[type], this.advances[mapKey] >= this.advances[type])
                        if (this.advances[mapKey] >= this.advances[type]) {
                            lowAdvance = false
                            break
                        }
                    }
                    lowAdvance && (this.$set(this.row, this.map[mapKey], null))
                }
            },
            handleClickSuffixIcon() {
                this.handleConfirm(this.types.reduce((ret, key) => {
                    ret[key] = null
                    return ret
                }, {}))
            },
        }
    }
</script>

<style lang="scss">
    .link-address-input {
        box-sizing: border-box;
    }
</style>
